import { render, staticRenderFns } from "./IAlert.vue?vue&type=template&id=a264f9d4&scoped=true&"
import script from "./IAlert.vue?vue&type=script&lang=js&"
export * from "./IAlert.vue?vue&type=script&lang=js&"
import style0 from "./IAlert.vue?vue&type=style&index=0&id=a264f9d4&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a264f9d4",
  null
  
)

export default component.exports